import { STAKKO_APP_URLS } from './config';
import type { StakkoAppDefinition, StakkoAppId } from './types';

/**
 * Katalog všech aplikací v ekosystému. Používá ho přepínač aplikací v railu
 * i dashboard. URL jde přepsat přes VITE_STAKKO_URL_*.
 */
export const STAKKO_APPS: StakkoAppDefinition[] = [
  {
    id: 'vserozvrh',
    name: 'Všerozvrh',
    tagline: 'Rozvrh bez kolizí a oken',
    url: STAKKO_APP_URLS.vserozvrh,
    color: '#7c3aed',
    icon: 'calendar',
  },
  {
    id: 'noddo',
    name: 'Noddo',
    tagline: 'Myšlenkové mapy a poznámky',
    url: STAKKO_APP_URLS.noddo,
    color: '#4f46e5',
    icon: 'brain',
  },
  {
    id: 'reppo',
    name: 'Reppo',
    tagline: 'Tréninkový deník a 1RM',
    url: STAKKO_APP_URLS.reppo,
    color: '#10b981',
    icon: 'dumbbell',
  },
  {
    id: 'planno',
    name: 'Planno',
    tagline: 'Akce, hlasování a RSVP',
    url: STAKKO_APP_URLS.planno,
    color: '#f59e0b',
    icon: 'ticket',
  },
  {
    id: 'dukato',
    name: 'Dukato',
    tagline: 'Investice a osobní finance',
    url: STAKKO_APP_URLS.dukato,
    color: '#2563eb',
    icon: 'wallet',
  },
  {
    id: 'dailo',
    name: 'Dailo',
    tagline: 'Denní přehled na jednom místě',
    url: STAKKO_APP_URLS.dailo,
    color: '#0f172a',
    icon: 'layout',
  },
  {
    id: 'monopoly',
    name: 'Frakto',
    tagline: 'Frakční akcie hrou',
    url: STAKKO_APP_URLS.monopoly,
    color: '#e11d48',
    icon: 'dice',
  },
];

export function getStakkoApp(id: StakkoAppId): StakkoAppDefinition | undefined {
  return STAKKO_APPS.find((app) => app.id === id);
}
